import React, {useEffect, useState} from 'react'
import {faThumbsUp, faRotate} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axios from "axios";
import {CSRF, SanitizeHTML} from "../../../constants";
import {errorNotify} from "../../../utils/app";
import {editMessage} from "../../../actions/direct_messages";
import {useDispatch} from "react-redux";
import {faCircleExclamation} from "@awesome.me/kit-a13c95776b/icons/modules/classic/regular";
import Button from "../Button";
import ReactTooltip from "react-tooltip";
import Translate from "../CommentItem/Actions/Translate";

const Item = ({dm}) => {
    const dispatch = useDispatch()
    const {reply, message, page_id, attachment_type, attachment_url, attachment_expired, has_error, error_msg} = dm.attributes
    const [load, setLoad] = useState(false)
    const [displayMessage, setDisplayMessage] = useState(message || '')

    // useEffect(()=>{
    //     ReactTooltip.rebuild()
    // },[error_msg])
    useEffect(() => {
        // keep in sync if message changes from server / redux
        setDisplayMessage(message || '')
    }, [message])

    const isMobile = /Mobi|Android/i.test(navigator.userAgent)

    const reloadAttachment = (e) => {
        e.preventDefault()
        setLoad(true)

        axios({
            method: 'post',
            url: `/pages/${page_id}/direct_messages/${dm.id}/reload_attachment`,
            headers: { 'Content-Type': 'application/json',
                'X-CSRF-Token': CSRF}
        }).then(response => {
            setLoad(false)
            dispatch(editMessage(response.data.data.id, response.data.data.attributes))
        }).catch(error => {
                setLoad(false)
            }
        );
    }

    const renderMessage = () => {
        switch(attachment_type) {

            case "like":   return <FontAwesomeIcon icon={faThumbsUp} className="fa-fw"/>;
            case "image":   return <img className="msg-image" src={attachment_url} />;
            case "audio":   return <audio controls src={attachment_url}></audio>;
            default:      return <SanitizeHTML html={displayMessage} />
        }
    }

    return (
        <div className={`message-w ${reply ? 'out' : ''}`}>
            <div className={`message ${reply ? 'out' : ''} ${attachment_type && !attachment_expired ? 'attachment' : ''}`} >
                {(attachment_expired && attachment_type != "fallback") ?
                    <div className="expired-attach">
                        <div onClick={reloadAttachment}><FontAwesomeIcon icon={faRotate} spin={load} className="fa-fw"/></div>
                        <span>Reload {attachment_type}</span>
                    </div>
                    : renderMessage()}
            </div>
            {!reply && !attachment_type &&
                <Translate
                    dm
                    pageId={page_id}
                    objectId={dm.id}
                    isMobile={isMobile}
                    className="square-btn msg-translate-btn"
                    onBubbleChange={(translatedText) => {
                        setDisplayMessage(translatedText || '')
                    }}
                />}
            {has_error && <div className='msg-error'>
                <FontAwesomeIcon data-tip={error_msg} icon={faCircleExclamation} className="fa-fw"/>
            </div>}
            {/*<ReactTooltip effect="solid" html={false} className="switch-tooltip"/>*/}

        </div>
    )
}

export default React.memo(Item)